import React from "react";
import { Alert } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import * as Yup from "yup";
import axiosInstant from "../../../api";

const initialCreateProjectValues = {
  title: "",
};

const CreateProjectSchema = Yup.object().shape({
  title: Yup.string().required(),
});

export const CreateProjectFormProps = {
  initialValues: initialCreateProjectValues,
  validationSchema: CreateProjectSchema,
};

export interface IChannel {
  id: number;
  name: string;
  description: string;
  deactivated: boolean;
  subChannels: ISubChannel[];
}

export interface ISubChannel {
  id: number;
  channel_id: number;
  name: string;
  description: string;
  deactivated: boolean;
}

export interface ISelection {
  project_id?: number;
  brand_project_id?: number;
  embed_id: number;
  s3_file_id: number;
  channel_id: number;
  sub_channel_id: number;
  status?: string;
  placement_url?: string;
  impressions?: number;
  plays?: number;
  likes?: number;
  watch_time?: number;
  deactivated: boolean;
  isDirty?: boolean;
}

export const SubHeaderTabs = (count = 0) => {
  const countText = count ? `(${count})` : "";
  return ["Video Carousel Player", `Individual Video Players ${countText}`];
};

export const shouldShowSubTab = (
  channels: Array<IChannel>,
  tabValue: number
): boolean => {
  if (!channels.length || tabValue >= channels.length) return false;
  return ["Website", "Email/Text", "QR"].includes(channels[tabValue].name);
};

export const callApi = async (url: string) => {
  try {
    const { data } = await axiosInstant.get(url);
    return data;
  } catch (err) {
    console.log((err as Error)?.message);
    return null;
  }
};

export const socialMediaTip = (
  <Alert icon={<InfoIcon fontSize="inherit" />} severity="error">
    <strong>Expert Tip:</strong> 16x9 is usually not the best aspect ratio for
    social media. Most social platforms support square and vertical video.
  </Alert>
);
